import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { EventType } from '@/types/events';
import { EVENT_TYPE_LABELS } from '@/types/events';

interface EventTypeBadgeProps {
  type: EventType;
  /** When true, renders with solid bg for image overlay contrast */
  overlay?: boolean;
}

export function EventTypeBadge({ type, overlay }: EventTypeBadgeProps) {
  const isCourse = type === 'course';

  return (
    <Badge
      variant="secondary"
      className={cn(
        'font-normal',
        overlay && 'bg-background/90 text-foreground backdrop-blur-sm border-border/50 shadow-sm',
        isCourse && !overlay && 'bg-[hsl(var(--course-badge-bg))] text-[hsl(var(--course-badge-fg))] border-[hsl(var(--course-badge-border))]',
        isCourse && overlay && 'bg-[hsl(var(--course-badge-bg)/0.95)] text-[hsl(var(--course-badge-fg))] backdrop-blur-sm border-[hsl(var(--course-badge-border)/0.5)] shadow-sm',
      )}
    >
      {EVENT_TYPE_LABELS[type]}
    </Badge>
  );
}
